import "./BaseHeader.css";
import React from "react";
import PropTypes from "prop-types";
import Propulator from "higher-order/Propulator";
import MobileMenuItem from "./MobileMenuItem";
import classNames from "classnames";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { BaseHeaderContext } from "../../mixins/HeaderItem";
import autobind from "autobind-decorator";
@observer
class BaseHeader extends React.Component {
    @observable mobileMenuOpen;

    constructor(props) {
        super(props);
        this.mobileMenuOpen = false;
    }

    static propTypes = {
        className: PropTypes.string,
        mobileRender: PropTypes.element,
        disableMobileTransform: PropTypes.bool,
        disableDesktopTransform: PropTypes.bool
    };

    @autobind
    handleMobileMenuClick() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    render() {
        return (
            <header className={classNames("page-header", this.props.className)}>
                <BaseHeaderContext.Provider value={{
                    selectedHeaderItem: this.props.selectedHeaderItem,
                    isMobileMenu: false,
                    enableAnimations: true,
                    disableTransform: this.props.disableDesktopTransform
                }}
                >
                    <div className="full-screen-header">
                        {this.props.children}
                    </div>
                </BaseHeaderContext.Provider>
                <div className="small-screen-header">
                    <BaseHeaderContext.Provider value={{
                        selectedHeaderItem: this.props.selectedHeaderItem,
                        isMobileMenu: this.mobileMenuOpen,
                        enableAnimations: false,
                        disableTransform: this.props.disableMobileTransform
                    }}
                    >
                        <MobileMenuItem
                            className="small-screen-header"
                            isLoggedIn={this.props.session?.isLoggedIn}
                            url="/"
                            enableOnFocus={false}
                            handleMobileMenuClick={this.handleMobileMenuClick}
                            requestInfoUrl={this.props.session?.requestInfoUrl}
                        >
                            {this.props.mobileRender ? this.props.mobileRender : this.props.children}
                        </MobileMenuItem>
                    </BaseHeaderContext.Provider>
                </div>
            </header>
        );
    }
}

export default Propulator(BaseHeader, {
    sessionStore: {
        session: "session"
    }
});